import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ShSortSelectComponent } from './components/sort-select/sort-select.component';
import { ShViewToggleComponent } from './components/view-toggle/view-toggle.component';
import { ALL_DISPLAY_MODES, DisplayMode } from './entities/display-mode.entity';
import { SortInfo, defaultSortInfo } from './entities/sort-info.entity';
import { SortOption } from './entities/sort-option.entity';

@Component({
    standalone: true,
    selector: 'sh-display-settings-bar',
    templateUrl: './display-settings-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShSortSelectComponent, ShViewToggleComponent, TranslateModule]
})
export class ShDisplaySettingsBarComponent {
    public displayMode$: BehaviorSubject<DisplayMode> = new BehaviorSubject<DisplayMode>(DisplayMode.LIST);
    public sortInfo$: BehaviorSubject<SortInfo> = new BehaviorSubject<SortInfo>(defaultSortInfo);
    public displayModes: typeof DisplayMode = DisplayMode;

    @Input() set displayMode(displayMode: DisplayMode) {
        this.displayMode$.next(displayMode);
    }

    @Input() set sortInfo(sortInfo: SortInfo) {
        this.sortInfo$.next(sortInfo);
    }

    @Input() sortOptions: SortOption[];

    @Input() displayOptions: DisplayMode[] = ALL_DISPLAY_MODES;

    @Input() showSortSelect = true;
    @Input() showViewToggle = true;

    @Input() totalResults: number;

    // TODO: convert to i18n object
    @Input() xxResultsLabelKey: string;
    @Input() noResultsLabelKey: string;

    @Input() sortPrefixMessage: string;
    @Input() sortLoadingMsg: string;

    @Output() displayModeChanged: EventEmitter<DisplayMode> = new EventEmitter<DisplayMode>();
    @Output() sortInfoChanged: EventEmitter<SortInfo> = new EventEmitter<SortInfo>();

    onViewModeSelected(displayMode: DisplayMode): void {
        this.displayModeChanged.emit(displayMode);
    }

    onSortInfoChanged(sortInfo: SortInfo): void {
        this.sortInfoChanged.emit(sortInfo);
    }
}
